import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Header = styled.div`
  > div {
    margin-bottom: 8px;

    > span {
      display: flex;
      margin: 0;
    }
  }
`

export const Checkout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--gray200);
`

export const Link = styled.span`
  color: var(--primary500);
  font-weight: 700;
`

export const BottomSheetContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  h3 {
    margin: 24px 0 8px;
  }

  button {
    margin-top: 24px;
  }
`
